export default "__VITE_ASSET__7aWupdeb__"